import { Pipe } from '@angular/core';
import { count } from '../utils/utils';
var CountPipe = (function () {
    function CountPipe() {
    }
    CountPipe.prototype.transform = function (input) {
        return count(input);
    };
    return CountPipe;
}());
export { CountPipe };
CountPipe.decorators = [
    { type: Pipe, args: [{
                name: 'count'
            },] },
];
/** @nocollapse */
CountPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=count.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/count.pipe.js
// module id = 228
// module chunks = 103